// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/icon/index.css
// module id = 866
// module chunks = 148